import type { Y_Tools } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const yToolTableColumns: EquipmentTableColumn<Y_Tools>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "manufacturer",
    header: "Manufacturer",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "minimum_inches",
    header: "Min Length (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "length_inches",
    header: "Length (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "width_inches",
    header: "Width (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  },
  {
    editable: true,
    field: "maximum_inches",
    header: "Max Length (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "series_model",
    header: "Series/Model",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "outer_diameter_inches",
    header: "Outer Diameter (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "teleswivel_stroke_length_inches",
    header: "Teleswivel Stroke Length (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "pressure_rating_psi",
    header: "Pressure Rating (psi)",
    isNumber: true,
    sortable: true,
    searchable: true,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "temperature_rating_fahrenheit",
    header: "Temperature Rating (°F)",
    isNumber: true,
    sortable: true,
    searchable: true,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "handling_sub_connection_inches",
    header: "Handling Sub Connection (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "bypass_connection_inches",
    header: "Bypass Connection (in)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "material_type",
    header: "Material Type",
    sortable: true,
    searchable: true,
    hidden: true // Temporarily hidden in admin view - remove hidden property to add column back
  },
  {
    editable: true,
    field: "weight_pounds",
    header: "Weight (lb)",
    isNumber: true,
    sortable: true,
    searchable: true,
    decimalPlaces: 6
  }
];
